<span matDialogTitle>{{ 'Anteprima documento' | siaTranslate }}</span>
<button mat-icon-button matDialogClose (click)="onClose()">
  <mat-icon> close </mat-icon>
</button>
<mat-dialog-content>
  @if (loading()) {
    <div class="flex h-full w-full items-center justify-center">
      <mat-spinner diameter="48"></mat-spinner>
    </div>
  } @else if (error()) {
    <div class="flex h-full w-full flex-col items-center justify-center gap-2 p-6 text-center text-red-700">
      <mat-icon class="h-[48px] w-[48px] text-[48px]">error_outline</mat-icon>
      <span>{{ error() }}</span>
    </div>
  } @else if (fileBlob()) {
    <sia-base-pdf-viewer
      class="block h-full w-full"
      [file]="fileBlob()!"
      (scrolledToEnd)="onScrolledToEnd()"
    ></sia-base-pdf-viewer>
  }
</mat-dialog-content>

@if (data().showConfirmButton) {
  <div matDialogActions align="end" class="flex items-center gap-3">
    @if (data().enableActionsOnScrollEnd && !canConfirm()) {
      <span class="text-sm text-[var(--mat-app-on-surface-variant)]">
        {{ 'Scorri fino alla fine del documento per confermare' | siaTranslate }}
      </span>
    }
    <button mat-button (click)="onConfirm()" [disabled]="!canConfirm()" [autofocus]="true">
      {{ 'Conferma' | siaTranslate }}
    </button>
  </div>
}
